var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "card w-modal h-modal", attrs: { id: "donation-payment" } },
    [
      _c("div", { staticClass: "header" }, [
        _vm._m(0),
        _c(
          "div",
          {
            staticClass: "close",
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          },
          [_c("i", { staticClass: "icn icn-x sm" })]
        )
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoadingPayment,
              expression: "!isLoadingPayment"
            }
          ],
          staticClass: "content"
        },
        [
          _vm._m(1),
          _vm.payload.donation.paymentType === _vm.creditCard
            ? _c(
                "div",
                [
                  _c("h2", [_vm._v("Credit Card Details")]),
                  _c("bambora-credit-card-form", {
                    key: _vm.bamboraFormKey,
                    on: {
                      startProcessingPayment: function($event) {
                        _vm.isLoadingPayment = true
                      },
                      finishProcessingPayment: function($event) {
                        _vm.isLoadingPayment = false
                      },
                      success: _vm.processDonation,
                      error: _vm.onError
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.payload.donation.paymentType === _vm.directDebit
            ? _c(
                "div",
                [
                  _c("h2", [_vm._v("Bank Account Details")]),
                  _c("bambora-direct-debit-form", {
                    key: _vm.bamboraFormKey,
                    on: {
                      startProcessingPayment: function($event) {
                        _vm.isLoadingPayment = true
                      },
                      finishProcessingPayment: function($event) {
                        _vm.isLoadingPayment = false
                      },
                      success: _vm.processDonation
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.errorMessage
            ? _c("alert", {
                staticClass: "mt-4",
                attrs: { message: _vm.errorMessage }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isLoadingPayment,
              expression: "isLoadingPayment"
            }
          ],
          staticClass: "content"
        },
        [_vm._m(2)]
      ),
      !_vm.isLoadingPayment
        ? _c("div", { staticClass: "footer" }, [
            _c(
              "button",
              {
                staticClass: "secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.$emit("previousStep")
                  }
                }
              },
              [_vm._v("Back")]
            ),
            _c("div", { staticClass: "flex-grow" })
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("div", { staticClass: "flex flex-col" }, [
        _c("h1", { staticClass: "mb-2" }, [_vm._v("New Donation")]),
        _c("div", { staticClass: "flex flex-row" }, [
          _c("h4", { staticClass: "opacity-50" }, [
            _vm._v("Supporter Details")
          ]),
          _c("h4", { staticClass: "ml-4 mr-4 opacity-50" }, [_vm._v(">")]),
          _c("h4", { staticClass: "opacity-50" }, [_vm._v("Donation Details")]),
          _c("h4", { staticClass: "ml-4 mr-4" }, [_vm._v(">")]),
          _c("h4", [_vm._v("Payment")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-5 mt-5 flex flex-row items-center" }, [
      _c("img", {
        staticClass: "w-24",
        attrs: { src: require("@/assets/img/secure-icon.svg") }
      }),
      _c("div", { staticClass: "flex flex-col ml-2 uppercase" }, [
        _c("div", { staticClass: "font-bold" }, [_vm._v("Secure")]),
        _c("div", [_vm._v("Payment")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-col items-center" }, [
      _c("img", {
        staticClass: "h-40 mb-14 mt-20",
        attrs: { src: require("@/assets/img/loading.svg") }
      }),
      _c("div", { staticClass: "flex flex-col items-center" }, [
        _c("h1", { staticClass: "mb-10" }, [_vm._v("Processing The Payment")]),
        _c("h1", [_vm._v("Do not navigate")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }